import { render, staticRenderFns } from "./PostSearchScreen.vue?vue&type=template&id=e8e68eda&scoped=true"
import script from "./PostSearchScreen.vue?vue&type=script&lang=js"
export * from "./PostSearchScreen.vue?vue&type=script&lang=js"
import style0 from "./PostSearchScreen.vue?vue&type=style&index=0&id=e8e68eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e68eda",
  null
  
)

export default component.exports